// src/utils/formatDate.js

export const formatDate = (dateString, style = "long") => {
  const date = new Date(dateString);
  const options =
    style === "short"
      ? { year: "numeric", month: "short", day: "numeric" }
      : { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};
